<template>
  <div class="top5">
    <div class="row" v-for="(item, index) in slots" :key="'top5-' + index">
      <div class="meta">
        <span class="rank" :class="'r' + (index + 1)">{{ index + 1 }}</span>
        <span class="name">{{ item.title }}</span>
        <span class="num">{{ item.value }}</span>
      </div>
      <div class="track">
        <div
          class="bar"
          :style="{ width: item.progress + '%', background: colors[index] }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
const COLORS = ["#00e5ff", "#58e2f1", "#1890ff", "#4dabff", "#7eb6d9"];

export default {
  name: "progressSelf",
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return { colors: COLORS };
  },
  computed: {
    slots() {
      const src = Array.isArray(this.list) ? this.list : [];
      const result = [];
      for (let i = 0; i < 5; i++) {
        const item = src[i];
        result.push({
          title: (item && item.title) || "-",
          value: item && item.value != null ? item.value : 0,
          progress: Math.max(0, Math.min(100, Number((item && item.progress) || 0))),
        });
      }
      return result;
    },
  },
};
</script>

<style scoped>
.top5 {
  width: 100%;
  height: 100%;
  min-height: 140px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 2px 0;
}

.row {
  flex: 1 1 20%;
  height: 20%;
  min-height: 0;
  max-height: 20%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
  padding: 2px 4px;
}

.meta {
  display: flex;
  align-items: center;
  min-width: 0;
  margin-bottom: 4px;
}

.rank {
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  margin-right: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  color: #00e5ff;
  border: 1px solid rgba(0, 229, 255, 0.45);
  background: rgba(0, 60, 100, 0.4);
}

.r1 {
  color: #ffa940;
  border-color: rgba(255, 169, 64, 0.55);
}

.name {
  flex: 1;
  min-width: 0;
  font-size: 12px;
  color: #b8d4e8;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.num {
  flex-shrink: 0;
  margin-left: 8px;
  font-size: 12px;
  font-weight: 700;
  color: #00e5ff;
  text-shadow: 0 0 6px rgba(0, 229, 255, 0.45);
}

.track {
  width: 100%;
  height: 6px;
  flex-shrink: 0;
  background: rgba(0, 40, 80, 0.55);
  overflow: hidden;
}

.bar {
  height: 100%;
  max-width: 100%;
  transition: width 0.3s ease;
  box-shadow: 0 0 6px rgba(0, 229, 255, 0.35);
}
</style>
